import { useContext } from 'react';
import OfflineContext from './offline-context';

const useOffline = () => {
  const oatData = useContext<any>(OfflineContext);
  return oatData;
};

export default useOffline;
